module.exports = __webpack_public_path__ + "static/media/neva-net.bb34651d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/neva/neva-net.png
// module id = 343
// module chunks = 0